import * as React from 'react'
import { FC } from 'react'
import { Formik } from 'formik'

import { useGetLeadNoteOnMount } from '@user/store/leadNotes/hooks/useGetLeadNoteOnMount'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { AddNoteFormFieldsModalForm } from '@user/components/Notes/AddNoteDrawer/AddNoteForm/AddNoteFormFieldsModalForm'
import { usePestPacNoteOptionsSelector } from '@user/components/Notes/EditNoteDrawer/hooks/useNoteLocationSelector'
import { useHandlers } from '@user/components/Notes/EditNoteDrawer/hooks/useHandlers'

interface Props {
  leadId: number
  noteId: number
  onClose: () => void
  onUpdateSuccess: () => void
  onGoBack?: () => void
  externalLinkId?: string
}

export const EditLeadNoteFormWrapper: FC<Props> = (props) => {
  const { leadId, noteId, onUpdateSuccess, externalLinkId, onGoBack } = props
  const { matchedLocations, serviceOptions, noteCodes } =
    usePestPacNoteOptionsSelector()
  const [status, note] = useGetLeadNoteOnMount(noteId)
  const { onSubmitLeadNote, validate } = useHandlers({
    entityId: leadId,
    noteId,
    onUpdateSuccess,
    onGoBack,
    serviceOptions: matchedLocations || [],
  })

  return (
    <>
      {status == 'pending' && (
        <Box p={2} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}

      {status == 'success' && !!note && noteCodes.length > 0 && (
        <Formik
          initialValues={{
            title: note.title,
            detail: note.detail,
            addNotesToPestPac: false,
            serviceLocation:
              serviceOptions?.length === 1 ? serviceOptions[0].value : '',
            code: noteCodes.find((code) => code.isDefault)?.name || '',
          }}
          onSubmit={onSubmitLeadNote}
          validate={validate}
        >
          <AddNoteFormFieldsModalForm
            externalLocationId={externalLinkId}
            serviceOptions={serviceOptions}
            noteCodes={noteCodes}
          />
        </Formik>
      )}

      {status == 'fail' && <Alert severity="error">Failed to load note.</Alert>}
    </>
  )
}

EditLeadNoteFormWrapper.displayName = 'EditLeadNoteFormWrapper'
